let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dBXMX")).then(() => parcelRequire('3TQcd'));